<div fxLayout="column" fxLayoutGap="20px">
  <h1>Documentos Inscrições do Concurso:</h1>
  <h2>{{concursoTitulo}}</h2>

  <mat-form-field appearance="outline">
    <mat-label>Documento</mat-label>
    <mat-select [formControl]="tipoDocumentoFc">
      <mat-option *ngFor="let enum of tipoDocumentoOpcoes | keyvalue" [value]="enum.key">
        {{ enum.value }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <app-search-input #searchInput></app-search-input>

  <div class="card-info card-icon">
    <mat-icon>info</mat-icon>
    <span>Formatos aceitos para upload: <strong>PDF</strong> e <strong>PDF com OCR</strong> (reconhecimento óptico de caracteres).</span>
  </div>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="id">#</th>
        <td mat-cell *matCellDef="let row">{{ row.id }}</td>
      </ng-container>
      <ng-container matColumnDef="concurso">
        <th mat-header-cell *matHeaderCellDef>Concurso</th>
        <td mat-cell *matCellDef="let row">
          <p [matTooltip]="row.campus">{{ row.siglaUnidade }}</p>
          <p>{{ row.tituloConcurso }}</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="inscricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="inscricao">Inscrição</th>
        <td mat-cell *matCellDef="let row">
          <p>{{ row.data | date : 'dd/MM/yyyy HH:mm:ss' }}</p>
          <p *ngIf="!isDepartamento">{{ row.protocolo }}</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="candidato">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="candidato">Candidato</th>
        <td mat-cell *matCellDef="let row">
          <p>{{ row.nomeSocial || row.nome }}</p>
          <p><b>CPF</b> {{ row.cpf }}</p>
          <p><b>RG</b> {{ row.rg }}</p>
          <p *ngIf="row.ausente" style="color: #d32f2f; font-weight: bold;">⚠ AUSENTE</p>
          <p *ngIf="isNaoHabilitado(row)" style="color: #d32f2f; font-weight: bold;" title="Candidato não habilitado para esta fase">⚠ NÃO HABILITADO</p>
        </td>
      </ng-container>
      <ng-container matColumnDef="contato">
        <th mat-header-cell *matHeaderCellDef>Contato</th>
        <td mat-cell *matCellDef="let row">
          <p>{{ row.email }}</p>
          <p>{{ row.celular }}</p>
          <p>{{ row.telefone }}</p>
        </td>
      </ng-container>

      <ng-container matColumnDef="documento">
        <th mat-header-cell *matHeaderCellDef>{{ tipoDocumentoStr(documentoSelecionado) }}</th>
        <td mat-cell *matCellDef="let row; let i = index">
          <div *ngIf="isUploadBloqueado(row); else documentoActions">
            <span *ngIf="documentoAnexado(row)" style="color: #999;">
              <button mat-icon-button color="basic" (click)="visualizarDocumento(row)" title="Visualizar documento (candidato bloqueado)">
                <mat-icon style="color: #d32f2f;">description</mat-icon>
              </button>
            </span>
            <span *ngIf="!documentoAnexado(row)" style="color: #999;">—</span>
          </div>
          <ng-template #documentoActions>
          <div *ngIf="documentoAnexado(row); then editarDocumentoMenu; else adicionarDocumentoBtn"></div>
          </ng-template>
          <ng-template #adicionarDocumentoBtn>
            <button *ngIf="documentoSelecionado !== 'NOTAS_SEGUNDA_FASE'" mat-icon-button color="basic" (click)="enviarDocumento(row)" title="Adicionar">
              <mat-icon>add</mat-icon>
            </button>
          </ng-template>
          <ng-template #editarDocumentoMenu>
            <button mat-icon-button color="basic" [matMenuTriggerFor]="menu" title="Documento">
              <mat-icon>description</mat-icon>
            </button>
            <button *ngIf="getReporteParaInscricao(row.id)" mat-icon-button
              (click)="abrirHistoricoReporte(row.id)"
              [matTooltip]="'Reporte de identificação: ' + getReporteParaInscricao(row.id)?.status"
              class="reporte-indicator">
              <mat-icon [color]="getReporteStatusClass(row.id)" [style]="getReporteIconStyle(row.id)">warning</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item color="basic" (click)="visualizarDocumento(row)" title="Visualizar">
                <mat-icon>file_open</mat-icon><span>Visualizar</span>
              </button>
              <button *ngIf="documentoSelecionado !== 'NOTAS_SEGUNDA_FASE'" mat-menu-item color="basic" (click)="enviarDocumento(row)" title="Substituir">
                <mat-icon>refresh</mat-icon><span>Substituir</span>
              </button>
              <button mat-menu-item color="warn" (click)="excluirDocumento(row, i)" title="Excluir">
                <mat-icon>delete</mat-icon><span>Excluir</span>
              </button>
            </mat-menu>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="8">
          <app-table-no-data [searchValue]="searchInput?.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator [length]="totalElements"></app-default-paginator>

    <input type="file" #fileInput (change)="selecionaArquivo($event)" class="visually-hidden" accept="application/pdf" />
  </div>
</div>
